module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "faultSet"
    }
  }, [_c('div', {
    staticClass: "faultClass container"
  }, [_c('h4', [_vm._v("故障分类")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.faultClassLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "faultClassListPart listPart",
      on: {
        "click": function($event) {
          return _vm.selectFaultClass(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.faultTypesName) + "\n                    "), _c('span', {
      class: {
        active: _vm.activeIndex === index
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    })]), _vm._v(" "), (_vm.fauleAuth.exitFaultClass) ? _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exitFaultClass(item)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.fauleAuth.deleFaultClass) ? _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleFaultClass(item)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.fauleAuth.newFaultClass) ? _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newFaultClass()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.dislogFaultClass,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogFaultClass = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('FaultClassForm')
      }
    }
  }, [_c('el-form', {
    ref: "FaultClassForm",
    attrs: {
      "model": _vm.FaultClassForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.FaultClassFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "故障分类：",
      "prop": "faultTypesName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入故障大类名称(不超过20个字)",
      "maxlength": "20"
    },
    model: {
      value: (_vm.FaultClassForm.faultTypesName),
      callback: function($$v) {
        _vm.$set(_vm.FaultClassForm, "faultTypesName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "FaultClassForm.faultTypesName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序：",
      "prop": "sort"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "number",
      "min": 0,
      "max": 99
    },
    model: {
      value: (_vm.FaultClassForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.FaultClassForm, "sort", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "FaultClassForm.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "故障描述"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.FaultClassForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.FaultClassForm, "memo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "FaultClassForm.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "clearfix",
    attrs: {
      "label": "展示图片：",
      "prop": "images"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader fl",
    attrs: {
      "data": _vm.postData,
      "accept": _vm.acceptImage,
      "action": "https://up.qiniup.com",
      "show-file-list": false,
      "on-success": _vm.handlePictureCardPreview,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.dialogImageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.dialogImageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader fl",
    attrs: {
      "data": _vm.postData,
      "accept": _vm.acceptImage,
      "action": "https://up.qiniup.com",
      "show-file-list": false,
      "on-success": _vm.handlePictureCardPreview2,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.dialogImageSrc) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.dialogImageSrc
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogMenuStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn('FaultClassForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveEventFormSubmitBtn('FaultClassForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('FaultClassForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "fault container"
  }, [_c('h4', [_vm._v("故障")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.faultLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "faultListPart listPart"
    }, [_c('p', [_vm._v(_vm._s(item.faultSubclassName))]), _vm._v(" "), (_vm.fauleAuth.exitFault) ? _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exitFault(item)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.fauleAuth.deleFault) ? _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleFault(item)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.fauleAuth.newFault) ? _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newFault()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textFaultMenu[_vm.dialogFaultStatus],
      "visible": _vm.dislogFault,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogFault = $event
      },
      "close": function($event) {
        return _vm.emptyFaultDialog('FaultForm')
      }
    }
  }, [_c('el-form', {
    ref: "FaultForm",
    attrs: {
      "model": _vm.FaultForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.FaultFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "故障简称：",
      "prop": "faultSubclassShortName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入故障简称(不超过20个字)",
      "maxlength": "20"
    },
    model: {
      value: (_vm.FaultForm.faultSubclassShortName),
      callback: function($$v) {
        _vm.$set(_vm.FaultForm, "faultSubclassShortName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "FaultForm.faultSubclassShortName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "故障名称：",
      "prop": "faultSubclassName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入故障小类名称(不超过30个字)",
      "maxlength": "30"
    },
    model: {
      value: (_vm.FaultForm.faultSubclassName),
      callback: function($$v) {
        _vm.$set(_vm.FaultForm, "faultSubclassName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "FaultForm.faultSubclassName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序：",
      "prop": "sort"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "number",
      "min": 0,
      "max": 99
    },
    model: {
      value: (_vm.FaultForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.FaultForm, "sort", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "FaultForm.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示图片：",
      "prop": "images"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "data": _vm.postData,
      "action": "https://up.qiniup.com",
      "show-file-list": false,
      "accept": _vm.acceptImage,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogFaultStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addFaultFormSubmitBtn('FaultForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveFaultFormSubmitBtn('FaultForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyFaultDialog('FaultForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-5763cb21","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/faultSet.vue
// module id = 1668
// module chunks = 0